<script>
    export default {
        data() {
            return {
                expanded: false,
                opened: null
            };
        },
        computed: {
            expandedClass() {
                return { 'expanded': this.expanded }
            }
        },
        mounted() {
            EventHandler.listen('expand-navigation', () => {
                this.expand();
            });
            EventHandler.listen('body-clicked', (event) => {
                if (!this.$el.contains(event.target)) {
                    this.hide();
                }
            });
        },
        methods: {
            expand() {
                if (this.expanded) {
                    this.hide();
                } else {
                    this.expanded = true;
                }
            },
            hide() {
                this.expanded = false;
                this.opened = null;
                EventHandler.fire('navigation-hidden')
            },
            isOpened(id) {
                return this.opened === id;
            },
            open(id) {
                if (this.isOpened(id)) {
                    this.opened = null;
                } else {
                    this.opened = id;
                }
            },
            openedClass(id) {
                return this.isOpened(id) ? 'opened' : null;
            }
        }
    };
</script>